export default "__VITE_ASSET__a990a294__"